import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.ja'
import yieldLadder from './yieldLadder.ja'

export default createLendingBundle({ whitepaper, yieldLadder })
